import { CloseOutlined } from '@ant-design/icons';
import { Col, Divider, Drawer, Radio, Row, Select, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { AFCProviders, SasProviders } from '../constants/SasProviders';
import { useAppContext } from '../context/TechnologyContext';
import { ApiHandler } from '../services/apiHandler';
import { getUser as getUserName } from '../services/helper';
import ErrorAlert from './ErrorAlert';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import SuccessAlert from './SuccessAlert';
import './TechnologyDrawer.css';
interface Props {
  open: boolean;
  setOpenDrawer: (val: boolean) => void;
  setActiveTechnology: (tech: string) => void;
}

export default function TechnologyDrawer(props: Props) {
  const navigate = useNavigate();

  const { techType, setTechType } = useAppContext();
  const [selectedProviderType, setSelectedProviderType] = useState<'null' | 'afc' | null>('afc');

  const [selectedSasProvider, setSasProvider] = useState('');
  const [apiKey, setApiKey] = useState('');
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successAlert, setSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [allOptions, setAllOptions] = useState<any>();
  const [selectedDeploymentType, setSelectedDeploymentType] = useState('');
  const [deployOption5g, setDeployOptions5g] = useState<any>();
  const [vendorOptionList, setVendorOptionList] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [modelOptionList, setModelOptionList] = useState<any[]>([]);
  const [selectedModal, setSelectedModal] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedAFCProvider, setSelectedAFCProvider] = useState('');
  const [bands, setBands] = useState<string[]>([]);
  const [selectedSasUserId, setSelectedSasUserId] = useState('');
  const [sasUserIdOptions, setSasUserIdOptions] = useState<any[]>([
    { label: '5T9MLG', value: '5T9MLG' },
    { label: 'c3spectra-inc', value: 'c3spectra-inc' },
  ]);
  const [techTypeLocal, setTechTypeLocal] = useState(techType);

  useEffect(() => {
    getUser();
  }, []);

  const listVendors = (type: string = '') => {
    ApiHandler({ apiName: 'listVendors', params: {}, body: {}, queryParams: { tech_type: type !== '' ? type : techTypeLocal } })
      .then((response: any) => {
        let vendor: any = response?.data;
        // console.group(response, 'reonse');
        setAllOptions(vendor);
        handleOptions(vendor);
        // setAerialVendorList(vendor.aerial);
        // setRoeVendorList(vendor.roe);
        // setSmbVendorList(vendor.smb);
        // setWifiVendorList(vendor.wifi);
        // setCpeWifiVendorList(vendor.cpe_wifi);
        // setCpeCbsdVendorList(vendor.cpe_cbsd);
        // getUser();
      })
      .catch((response: any) => {
        if (response.doLogout === true) {
          setErrorMessage('Session Timed Out');
          setErrorAlert(true);
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setErrorMessage(response.data.message);
          setErrorAlert(true);
        }
      });
  };

  const getUser = () => {
    //   setIsNotCPI(['installer', 'engineer'].includes(getRole()));
    ApiHandler({ apiName: 'getUser', params: {}, body: {} })
      .then((response: any) => {
        let user: any = response.data;
        console.log(response, 'responseeeee');
        // setUserId(user.user_id || '');
        setSasProvider(user.default_provider || '');
        setSelectedAFCProvider(user.default_afc_provider || '');
        setSelectedSasUserId(user.sas_user_id || '');
        setSelectedProviderType(['wifi_6e', 'tarana'].includes(user?.technology_type) ? 'afc' : null);
        // setTechType(user?.technology_type);
        listVendors();
        //   setAerialVendorId(user.default_aerial_vendor_id || 0);
        //   setRoeVendorId(user.default_roe_vendor_id || 0);
        //   setSmbVendorId(user.default_smb_vendor_id || 0);
        //   setWifiVendorId(user.default_wifi_vendor_id || 0);
        //   setCpeWifiVendorId(user.default_cpe_wifi_vendor_id || 0);
        //   setCpeCbsdVendorId(user.default_cpe_cbsd_vendor_id || 0);
        //   setCpiName(user.cpi_name || '');
        //   setUsername(user.username || '');
        //   setEmail(user.email || '');
        //   setCpiId(user.cpi_id || '');
        //   setCertificateUploaded(user.is_p12_uploaded || false);
        //   setCertificateFile(undefined);
        //   setCertPassword('');
        //   setProfilePicture(user);
        //   setTechnologyTypeTitle(user.technology_type);
        //   setSelectedProviderType(user.provider_type);
        //   setLoading(false);
        //   allowSettingsSave(false);
      })
      .catch((response: any) => {
        //   setLoading(false);
        if (response.doLogout === true) {
          setErrorMessage('Session Timed Out');
          setErrorAlert(true);
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setErrorMessage(response.data.message);
          setErrorAlert(true);
        }
      });
  };

  const handleOptions = (vendorList: any) => {
    if (Object.keys(vendorList).length > 0) {
      let deployOption5gTemp = { cbrs_5g: [] as any, wifi_6e: [] as any, '5g': [] as any, tarana: [] as any };
      Object.keys(vendorList).map((key) => {
        var label = key;
        if (key.length > 3 && key.split('_').length === 1) {
          label = key.charAt(0).toUpperCase() + key.slice(1);
        } else label = key.split('_')[0].toUpperCase();
        var value = key;
        if (label.toLowerCase() == 'aerial') label = 'Strand';
        if (label.toLowerCase() == 'roe') label = 'Macro';
        if (key.includes('wifi')) {
          if (label == 'Wifi') label = 'AP';
          deployOption5gTemp['wifi_6e'].push({ label: label, value: value });
        } else if (key == 'tarana') {
          deployOption5gTemp['tarana'].push({ label: 'Base Node', value: 'tarana' });
          deployOption5gTemp['tarana'].push({ label: 'Remote Node', value: 'tarana_cpe' });
        } else if (['aerial', 'roe', 'smb', 'cpe_cbsd'].includes(key)) {
          deployOption5gTemp['cbrs_5g'].push({ label: label, value: value });
          // deployOption5gTemp['5g'].push({ label: label, value: value });
        }
      });
      setDeployOptions5g(deployOption5gTemp);
    }
  };

  const techOptions = [
    { value: 'cbrs_5g', label: '5G' },
    { value: 'wifi_6e', label: 'Wi-Fi' },
    { value: 'tarana', label: 'Tarana Systems' },
  ];

  const changeDeploymentType = (val: string) => {
    setSelectedDeploymentType(val);
    setSelectedVendor('');
    setSelectedModal('');
    if (allOptions[val]) {
      var vendorTemp: any[] = [];
      // var optionTemp: any[] = []
      if (allOptions[val].length > 0) {
        allOptions[val].map((opt: any, index: number) => {
          vendorTemp.push({ label: opt['vendor_name'], value: opt['vendor_name'], key: index + opt['vendor_name'], id: opt['id'] });
          // optionTemp.push({ label: opt['vendor_model'], value: opt['vendor_model'] })
        });
      }
      setVendorOptionList(vendorTemp);
    }
  };

  // setModelOptionList(optionTemp)
  const changeTechType = (e: any) => {
    setTechType(e.target.value);
    if (e.target.value == 'wifi_6e') setSelectedProviderType('afc');
    else if (e.target.value == '5g') setSelectedProviderType(null);
    setSelectedDeploymentType('');
    setSelectedVendor('');
    setSelectedModal('');
  };

  const changeVendorType = (e: string) => {
    setSelectedVendor(e);
    if (allOptions[selectedDeploymentType]) {
      const fIndex = allOptions[selectedDeploymentType].findIndex((item: any) => item['vendor_name'] == e);
      if (fIndex !== -1) {
        setModelOptionList([
          { label: allOptions[selectedDeploymentType][fIndex]['vendor_model'], option: allOptions[selectedDeploymentType][fIndex]['vendor_model'] },
        ]);
        setSelectedModal(allOptions[selectedDeploymentType][fIndex]['vendor_model']);
      }
    }
  };
  const saveTech = () => {
    if (techTypeLocal) localStorage.setItem('technology_type', techTypeLocal);
    setTechType(techTypeLocal);
    const requestBody: any = { username: getUserName() };
    if (techTypeLocal && techTypeLocal.trim() !== '') requestBody.technology_type = techTypeLocal;
    if (selectedSasUserId && selectedSasUserId.trim() !== '') requestBody.sas_user_id = selectedSasUserId;
    if (selectedSasProvider && selectedSasProvider.trim() !== '') requestBody.default_provider = selectedSasProvider;
    if (selectedAFCProvider && selectedAFCProvider.trim() !== '') requestBody.default_afc_provider = selectedAFCProvider;
    if (selectedVendor) {
      console.log(selectedVendor, 'selcvendor');
      const isExist = allOptions[selectedDeploymentType].find((item: any) => item['vendor_name'] == selectedVendor);
      console.log(isExist, 'selcvendor');

      if (isExist) requestBody['default_aerial_vendor_id'] = isExist.id;
    }
    setLoading(true);
    ApiHandler({ apiName: 'updateUser', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        setSuccessAlert(true);
        setSuccessMessage(response.data.message);
        getUser();
        props.setActiveTechnology(techTypeLocal);
        props.setOpenDrawer(false);
        // window.location.reload();
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setErrorAlert(true);
          setErrorMessage('Session Timed Out');
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setErrorAlert(true);
          setErrorMessage(error.data.message);
        }
      });
  };

  // useEffect(() => {
  //   console.log(techType, 'techType');
  // }, [techType]);

  return (
    <Drawer
      title={
        <div className="text-color px-2 py-1 justify-content-between vertical-center">
          <Typography.Title level={5}>Active Technology</Typography.Title>
          <CloseOutlined onClick={() => props.setOpenDrawer(false)} className="cursor-pointer text-color-secondary" />
        </div>
      }
      closeIcon={null}
      open={props.open}
      width="45%"
      className="bg-sec">
      <Col span={24} className="col-wise space-between px-2 h-100">
        <Row>
          <Col span={6} className="col-wise">
            <Typography.Title level={5}>Choose Technology</Typography.Title>
            <div className=" mt-2">
              <Radio.Group
                options={techOptions}
                className="col-wise mt-1 custom-radio "
                value={techTypeLocal}
                onChange={(e) => {
                  // setTechType(e.target.value);
                  setTechTypeLocal(e.target.value);
                  setSelectedDeploymentType('');
                  setSelectedVendor('');
                  setSelectedModal('');
                  listVendors(e.target.value);
                }}
              />
            </div>
          </Col>
          <Divider type="vertical" className="h-100 px-2" />
          <Col span={16}>
            <Typography.Title level={5}>Settings</Typography.Title>
            {/* <div className="my-2"> */}
            {/* {(techType == '5g' || techType == 'cbrs_5g') && (
                <Checkbox
                  onChange={(e) => {
                    if (e.target.checked) {
                      setTechType('cbrs_5g');
                      listVendors('cbrs_5g');
                    } else {
                      setTechType('5g');
                      listVendors('5g');
                    }
                    if (e.target.value == 'cbrs_5g' && selectedProviderType == 'cbrs_5g') setSelectedProviderType(null);
                    else setSelectedProviderType('cbrs_5g');
                  }}
                  value="cbrs_5g"
                  checked={selectedProviderType === 'cbrs_5g'}>
                  CBRS (SAS)
                </Checkbox>
              )} */}
            {/* {['wifi_6e'].includes(techType) && (
                <Checkbox
                  onChange={(e) => {
                    if (e.target.value == 'afc' && selectedProviderType == 'afc') setSelectedProviderType(null);
                    else setSelectedProviderType('afc');
                  }}
                  value="afc"
                  checked={selectedProviderType === 'afc' ? true : false}>
                  {' '}
                  AFC{' '}
                </Checkbox>
              )} */}
            {/* </div> */}
            {/* {['tarana'].includes(techType) ? (
              <>
                <div className="sub-text py-2">Bands</div>
                <div className="d-flex gap-4 flex-row">
                  {TaranaBands.map((provider: any) => {
                    return (
                      <Checkbox
                        onChange={(e) => {
                          const value = e.target.value;
                          let localBands = [...bands];

                          if (bands.includes(value)) {
                            localBands = localBands.filter((val) => val != value);
                          } else {
                            localBands.push(value);
                          }
                          setBands(localBands);
                        }}
                        value={provider.value}
                        checked={bands.includes(provider.value)}>
                        {provider.name}
                      </Checkbox>
                    );
                  })}
                </div>
              </>
            ) : null} */}
            {['cbrs_5g', 'tarana'].includes(techTypeLocal) && (
              <div className="d-flex flex-column mt-4">
                <Typography.Text>SAS Provider</Typography.Text>
                <Radio.Group value={selectedSasProvider}>
                  <div className="row-wise gap-8 vertical-center">
                    {SasProviders.map((provider: any) => {
                      return (
                        <div
                          key={provider.alt}
                          className="row-wise gap-8"
                          onClick={() => {
                            setSasProvider(provider.alt);
                          }}>
                          <Radio checked={selectedSasProvider === provider.alt} value={provider.alt}>
                            <div
                              key={provider}
                              // className={selectedSasProvider === provider.alt ? 'sas-provider-active' : 'sas-provider'}
                              className="sas-provider">
                              <img src={provider.img} alt={provider.alt}></img>
                            </div>
                          </Radio>
                        </div>
                      );
                    })}
                  </div>
                </Radio.Group>
                <Typography.Text className="pb-2 pt-3">SAS User ID</Typography.Text>
                <Select
                  placeholder="Select SAS User ID"
                  value={selectedSasUserId}
                  onChange={(e) => setSelectedSasUserId(e)}
                  options={sasUserIdOptions}
                />
                <Divider />
              </div>
            )}

            {['wifi_6e', 'tarana'].includes(techTypeLocal) && (
              <div className="d-flex flex-column mt-4">
                <Typography.Text>AFC Provider</Typography.Text>
                <Radio.Group value={selectedAFCProvider}>
                  <div className="row-wise gap-8 vertical-center">
                    {AFCProviders.map((provider: any) => {
                      return (
                        <div
                          key={provider.alt}
                          className="row-wise gap-8"
                          onClick={() => {
                            setSelectedAFCProvider(provider.alt);
                          }}>
                          <Radio checked={selectedAFCProvider === provider.alt} value={provider.alt}>
                            <div
                              key={provider.alt}
                              // className={selectedSasProvider === provider.alt ? 'sas-provider-active' : 'sas-provider'}
                              className="sas-provider">
                              <img src={provider.img} alt={provider.alt}></img>
                            </div>
                          </Radio>
                        </div>
                      );
                    })}
                  </div>
                </Radio.Group>
                <Divider />
              </div>
            )}

            <div className="d-flex flex-column mt-3">
              {/* <Typography.Text>Deployment Type</Typography.Text>
              <Select
                placeholder="Select"
                value={selectedDeploymentType ? selectedDeploymentType : undefined}
                className="w-100 mt-2"
                options={deployOption5g && deployOption5g[techType]}
                onChange={changeDeploymentType}
              /> */}
              {vendorOptionList.length > 0 && (
                <div className="d-flex flex-row gap-8 mt-2">
                  <div className="col-wise w-100">
                    <Typography.Text>Vendor Make</Typography.Text>
                    <> {console.log(vendorOptionList, 'cendor')}</>
                    <Select
                      placeholder="Select"
                      className="w-100"
                      value={selectedVendor ? selectedVendor : undefined}
                      onChange={(e) => changeVendorType(e)}
                      options={vendorOptionList}
                    />
                  </div>
                  <div className="col-wise w-100">
                    <Typography.Text>Model</Typography.Text>
                    <Select
                      placeholder="Select"
                      className="w-100"
                      value={selectedModal ? selectedModal : undefined}
                      onChange={setSelectedModal}
                      options={modelOptionList}
                    />
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
        <Row justify={'end'}>
          <div className="row-wise vertical-center px-4 pt-3 pb-2 gap-3 right">
            <SecondaryButton className="w-100" label={'Cancel'} clicked={() => props.setOpenDrawer(false)} disable={false} />
            <PrimaryButton className="w-100 blue-bg" label="Save" clicked={() => saveTech()} disable={false} />
          </div>
        </Row>
      </Col>
      <ErrorAlert
        show={errorAlert}
        onDismiss={() => {
          setErrorAlert(false);
        }}
        message={errorMessage}
      />
      <SuccessAlert
        show={successAlert}
        onDismiss={() => {
          setSuccessAlert(false);
        }}
        message={successMessage}
      />
    </Drawer>
  );
}
